import { useNavigate } from 'react-router-dom';
import { MapPin, Phone, Mail } from 'lucide-react';
import { Logo } from '@/components/ui/Logo';

/** Clean, light marketplace footer shared across public pages. */
export const MarketFooter: React.FC = () => {
  const navigate = useNavigate();
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-secondary-100 dark:border-secondary-800 bg-secondary-50/70 dark:bg-slate-900 mt-16">
      <div className="container mx-auto px-4 py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          <div className="col-span-2 md:col-span-1">
            <Logo size="md" className="mb-4" />
            <p className="text-sm leading-relaxed text-secondary-500 dark:text-secondary-400 max-w-xs">
              Ghana's agricultural marketplace — fresh produce from farms to your door.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-bold uppercase tracking-wider text-secondary-900 dark:text-white mb-4">Shop</h4>
            <ul className="space-y-2.5 text-sm">
              <li><button onClick={() => navigate('/products')} className="text-secondary-500 dark:text-secondary-400 hover:text-primary-600 transition-colors">Marketplace</button></li>
              <li><button onClick={() => navigate('/cart')} className="text-secondary-500 dark:text-secondary-400 hover:text-primary-600 transition-colors">Your cart</button></li>
              <li><button onClick={() => navigate('/register')} className="text-secondary-500 dark:text-secondary-400 hover:text-primary-600 transition-colors">Create account</button></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-bold uppercase tracking-wider text-secondary-900 dark:text-white mb-4">Sell with us</h4>
            <ul className="space-y-2.5 text-sm">
              <li><button onClick={() => navigate('/register')} className="text-secondary-500 dark:text-secondary-400 hover:text-primary-600 transition-colors">Become a farmer</button></li>
              <li><button onClick={() => navigate('/register')} className="text-secondary-500 dark:text-secondary-400 hover:text-primary-600 transition-colors">Become a supplier</button></li>
              <li><button onClick={() => navigate('/register')} className="text-secondary-500 dark:text-secondary-400 hover:text-primary-600 transition-colors">Join as delivery agent</button></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-bold uppercase tracking-wider text-secondary-900 dark:text-white mb-4">Contact</h4>
            <ul className="space-y-3 text-sm text-secondary-500 dark:text-secondary-400">
              <li className="flex items-start gap-2.5">
                <span className="w-7 h-7 rounded-lg bg-primary-50 dark:bg-primary-900/20 flex items-center justify-center flex-shrink-0"><MapPin size={14} className="text-primary-500" /></span>
                Private Mail Bag, Accra
              </li>
              <li className="flex items-center gap-2.5">
                <span className="w-7 h-7 rounded-lg bg-primary-50 dark:bg-primary-900/20 flex items-center justify-center flex-shrink-0"><Phone size={14} className="text-primary-500" /></span>
                0244 736 002
              </li>
              <li className="flex items-center gap-2.5">
                <span className="w-7 h-7 rounded-lg bg-primary-50 dark:bg-primary-900/20 flex items-center justify-center flex-shrink-0"><Mail size={14} className="text-primary-500" /></span>
                support@asogro.com
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-secondary-200/70 dark:border-secondary-800 mt-12 pt-6 flex flex-col sm:flex-row justify-between items-center gap-3 text-sm text-secondary-400">
          <p>© {year} Asogro. All rights reserved.</p>
          <div className="flex gap-5">
            <a href="#" className="hover:text-primary-600 transition-colors">Privacy</a>
            <a href="#" className="hover:text-primary-600 transition-colors">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
